<template lang="pug" src="./app.pug"></template>

<script>
import Navigation from 'components/navigation/navigation'

export default {
  async created () {
    this.$store.dispatch('GET_PAGES')
    this.$store.dispatch('GET_APP')
    this.$store.dispatch('MODAL_CONTENT', false)
    this.$store.dispatch('SCROLLING', false)
    this.$store.dispatch('VIEW_DRAWER', false)
    this.$store.dispatch('VIEW_MODAL', false)
    this.$store.dispatch('VIEW_TYPES', 0)
  },
  components: {
    Navigation
  }
}
</script>

<style src='../main.sass' lang='sass'></style>



// WEBPACK FOOTER //
// src/base/app.vue